/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';


@Injectable()

export class TimelineProvider {

   
    
    
    

//
//    public updateOprMst(obj: any) {
//        
//       return this.serviceFirestore.modifyDocToFirestore(OPR_MST.name + "/" + obj.key,obj);
//    }
//
//
//    saveOpr(obj: any) {
//        const collecton = this.serviceFirestore.firestore.collection(OPR_MST.name);
//      
//        this.serviceFirestore.saveDocumentToFireStoreNew(collecton, obj, "OMD1");
//    }
}